import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { financeService } from "../../services/financeService";

/** Seçili günün kasa özeti (gelir/gider/net + hareketler). */
export const fetchDailyCash = createAsyncThunk(
  "finance/daily",
  async (date, { rejectWithValue }) => {
    try {
      const res = await financeService.daily(date);
      return res.data.data; // DailyCashResponse
    } catch (err) {
      return rejectWithValue(err.response?.data?.error ?? "Kasa yüklenemedi");
    }
  }
);

const financeSlice = createSlice({
  name: "finance",
  initialState: { daily: null, isLoading: false, error: null },
  reducers: {
    clearFinanceError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyCash.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDailyCash.fulfilled, (state, action) => {
        state.isLoading = false;
        state.daily = action.payload;
      })
      .addCase(fetchDailyCash.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearFinanceError } = financeSlice.actions;
export default financeSlice.reducer;
